import { zlibSync, unzlibSync, strToU8, strFromU8 } from "fflate";
function zip(data) {
  const buffer = strToU8(data);
  const zipped = zlibSync(buffer, { level: 9 });
  const binary = strFromU8(zipped, true);
  return btoa(binary);
}
function unzip(base64) {
  const binary = atob(base64);
  if (binary.startsWith("x\xDA")) {
    const buffer = strToU8(binary, true);
    const unzipped = unzlibSync(buffer);
    return strFromU8(unzipped);
  }
  return decodeURIComponent(escape(binary));
}
export {
  unzip,
  zip
};
//# sourceMappingURL=zip.js.map
